/**
 * Provides DOM-based PDF generation for the benefits page.
 * Captures the actual rendered React components (tables, colors, layout) and
 * converts to PDF so the PDF matches what the user sees on /benefits.
 *
 * When you change the /benefits page (components, sections, styling), the PDF
 * updates automatically because it captures the same DOM.
 */

import { type ReactNode, type RefObject, createContext } from 'react';

import { useBenefitsPdf } from '../hooks/useBenefitsPdf';

export interface BenefitsPdfContextValue {
  contentRef: RefObject<HTMLDivElement | null>;
  isCapturing: boolean;
  generatePdfFromDom: () => Promise<Blob>;
}

export const BenefitsPdfContext = createContext<BenefitsPdfContextValue | null>(
  null,
);

export const BenefitsPdfProvider = ({ children }: { children: ReactNode }) => {
  const value = useBenefitsPdf();
  return (
    <BenefitsPdfContext.Provider value={value}>
      {children}
    </BenefitsPdfContext.Provider>
  );
};
